import {
  clearScopedInvitationToken,
  setScopedInvitationToken,
} from './scopedInvitationSession';

export const SCOPED_INVITATION_ROUTE_PATH = '/scoped-invitation';

export const isScopedInvitationRoute = (pathname) => pathname === SCOPED_INVITATION_ROUTE_PATH;

export const extractScopedInvitationTokenFromHash = (hash) => {
  const fragment = typeof hash === 'string' && hash.startsWith('#') ? hash.slice(1) : hash || '';
  const params = new URLSearchParams(fragment);
  const tokenValues = params.getAll('token');

  if (tokenValues.length !== 1) {
    return {
      outcome: tokenValues.length > 1 ? 'ambiguous' : 'missing',
      token: null,
    };
  }

  const trimmedToken = tokenValues[0].trim();
  if (!trimmedToken) {
    return {
      outcome: 'missing',
      token: null,
    };
  }

  return {
    outcome: 'captured',
    token: trimmedToken,
  };
};

export const scrubScopedInvitationHash = (targetWindow = window) => {
  const nextUrl = `${targetWindow.location.pathname}${targetWindow.location.search}`;
  targetWindow.history.replaceState(targetWindow.history.state, '', nextUrl);
};

export const bootstrapScopedInvitationToken = (targetWindow = window) => {
  if (!isScopedInvitationRoute(targetWindow.location.pathname)) {
    return { outcome: 'ignored' };
  }

  const extracted = extractScopedInvitationTokenFromHash(targetWindow.location.hash);

  if (targetWindow.location.hash) {
    scrubScopedInvitationHash(targetWindow);
  }

  if (extracted.outcome === 'captured') {
    setScopedInvitationToken(extracted.token);
    return { outcome: 'captured' };
  }

  clearScopedInvitationToken();
  return { outcome: extracted.outcome };
};
